//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, between, decimal } from 'vuelidate/lib/validators';
import convert from 'convert-units';
import ValidationMixin from '../../../../common/form/mixins/ValidationMixin';

export default {
  name: 'MemberWeight',
  mixins: [ValidationMixin],
  props: ['value', 'updating', 'metric'],
  computed: {
    weight() {
      if (!this.isFloat(this.value)) {
        return this.value;
      }
      return Math.round(convert(this.value).from('kg').to('lb'));
    },
    convertedWeight() {
      if (!this.isFloat(this.value)) {
        return this.value;
      }

      if (this.metric) {
        return this.value.toFixed ? this.value.toFixed(1) : this.value;
      }
      return Math.round(convert(this.value).from('kg').to('lb'));
    },
  },
  validations: {
    weight: {
      // required,
      decimal,
      // between: between(25, 1400),
    },
  },
  methods: {
    onInput(data) {
      if (!this.isFloat(data)) {
        this.$emit('input', data);
      } else if (!this.metric) {
        this.$emit('input', convert(data).from('lb').to('kg'));
      } else {
        this.$emit('input', data);
      }
    },
    isFloat(n) {
      try {
        return n.toString().match(/^\d+(\.\d+)?$/);
      } catch (e) {
        return false;
      }
    },
    getErrors() {
      const errors = [];
      if (!this.$v.weight.required) {
        errors.push('Weight is required');
      }
      if (!this.$v.weight.decimal) {
        errors.push('Weight must be a number');
        return errors;
      }
      if (!this.$v.weight.between) {
        errors.push('You appear to have a typo in your weight');
      }
      return errors;
    },
  },
};
